export default __webpack_public_path__ + "static/b_vende_nissan-0c5ddf0cd56da645435a1948377f0f6c.png";